import PropTypes from 'prop-types';
import ButtonLink from 'sd-ui/dist/commonjs/components/ButtonLink/ButtonLink';
import Icon from '../../icon';
import ExtraPropTypes from '../extraPropType';
import { createDownloadAttachmentsLink } from '../../../utils/linkCreator';
import trackExtraFileDownload from '../../../utils/trackers/trackExtraFileDownload';

export default function DownloadAllExtraFiles({ files, pii, adobeContentType }) {
  return (
    <>
      <form
        method="post"
        action={createDownloadAttachmentsLink(pii)}
        onSubmit={() => trackExtraFileDownload(pii, 'MIME-ZIP', adobeContentType)}
      >
        {files.map(file => <input key={file.eid} name="eids" type="hidden" value={file.eid} />)}
        <ButtonLink
          icon={Icon.Download}
          className="call-to-action extras-popover-download-action"
          type="submit"
        >
          Download all (ZIP)
        </ButtonLink>
      </form>

      <ul className="extras-popover-file-list">
        {files.map(file => <li key={file.eid}><span>{file.label}</span></li>)}
      </ul>
    </>
  );
}

DownloadAllExtraFiles.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape(ExtraPropTypes)).isRequired,
  pii: PropTypes.string.isRequired,
  adobeContentType: PropTypes.string,
};

DownloadAllExtraFiles.defaultProps = {
  adobeContentType: undefined,
};
